export default "__VITE_ASSET__82b4b163__"